export default "__VITE_ASSET__03c29272__"